<template>
  <div class="rc-l-public rc-l-public--about">
    <div class="rc-l-public--title">
      <div class="container">
        <h1 class="mx-auto">{{ $t("statics.about.title") }}</h1>
      </div>
    </div>
    <!-- section 1 : Learn more with curio -->
    <section class="rc-section-follow-by-same-color">
      <div class="container text-center">
        <div class="row justify-content-center">
          <div class="col-lg-10 rc-col-text">
            <h2 v-html="$t('statics.about.section1.title')"></h2>
            <p
              class="mx-auto rc-intro--xl"
              v-html="$t('statics.about.section1.text')"
            ></p>
          </div>
        </div>
      </div>
    </section>
    <!-- section 2 : Relevant and inspiring content for everyone (list)-->
    <section class="rc-section-follow-by-same-color">
      <div class="container">
        <div class="row flex-column-reverse flex-md-row">
          <div
            class="col-md-7 col-xl-5 offset-xl-1 rc-col-text rc-col-max-width"
          >
            <h2 v-html="$t('statics.about.section2.title')"></h2>
            <h3 v-html="$t('statics.about.section2.list.title')"></h3>
            <ul class="rc-list-bullet">
              <li v-html="$t('statics.about.section2.list.1')"></li>
              <li v-html="$t('statics.about.section2.list.2')"></li>
              <li v-html="$t('statics.about.section2.list.3')"></li>
              <li v-html="$t('statics.about.section2.list.4')"></li>
              <li v-html="$t('statics.about.section2.list.5')"></li>
              <li v-html="$t('statics.about.section2.list.6')"></li>
              <li v-html="$t('statics.about.section2.list.7')"></li>
              <li v-html="$t('statics.about.section2.list.8')"></li>
              <li v-html="$t('statics.about.section2.list.9')"></li>
            </ul>
            <router-link :to="toMarketContent" class="btn btn-dark btn-lg">{{
              $t("statics.about.section2.cta")
            }}</router-link>
          </div>
          <div class="col-md-5 col-xl-6">
            <img
              src="/src/assets/img/illustrations/chameleon_combined.svg"
              class="rc-chameleon-combined"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
    <!-- section 3 : An intuitive, customizable platform-->
    <section>
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-lg-6 col-xl-5 offset-xl-1">
            <img
              src="/src/assets/img/illustrations/rhino_combined.svg"
              class="rc-rhino-combined"
              alt=""
            />
          </div>

          <div class="col-md-7 col-lg-6 rc-col-text rc-col-max-width">
            <h2 v-html="$t('statics.about.section3.title')"></h2>
            <h3 v-html="$t('statics.about.section3.list.title')"></h3>
            <ul class="rc-list-bullet">
              <li v-html="$t('statics.about.section3.list.1')"></li>
              <li v-html="$t('statics.about.section3.list.2')"></li>
              <li v-html="$t('statics.about.section3.list.3')"></li>
              <li v-html="$t('statics.about.section3.list.4')"></li>
            </ul>

            <router-link :to="toMarketExperience" class="btn btn-dark btn-lg">{{
              $t("statics.about.section3.cta")
            }}</router-link>
          </div>
        </div>
      </div>
    </section>

    <template v-if="!isAuthenticated">
      <!-- section 4 : Subscription -->
      <RcInfoSubscription cssClass="rc-bg-wave-plum-2" />
      <!-- section 5 : Widget verify subscription -->
      <RcVerifySubscription cssClass="rc-verify-subscription rc-section-last" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { navMixin } from "#/routes/mixins";

import RcInfoSubscription from "#/pages/market/components/sections/InfoSubscription.vue";
import RcVerifySubscription from "#/pages/market/components/sections/VerifySubscription.vue";

export default {
  name: "RcSiteAbout",
  components: {
    RcInfoSubscription,
    RcVerifySubscription
  },
  mixins: [navMixin],
  computed: {
    ...mapGetters(["isAuthenticated"])
  }
};
</script>

<style lang="scss"></style>
